import { useState } from "react";
import { HelpBrowser } from "./help-browser";

interface HelpPanelContentProps {
  initialSlug?: string | null;
}

export default function HelpPanelContent({ initialSlug }: HelpPanelContentProps) {
  const [slug, setSlug] = useState<string | null>(initialSlug ?? null);
  return (
    <div className="h-full px-1 pb-4">
      <HelpBrowser initialSlug={slug} onSlugChange={setSlug} />
    </div>
  );
}
